import * as AddressFormatter from "@shopify/address/build/ts/index";
import { useEffect, useState } from "react";
import { ShippingAddress } from "../ShippingAddress/useShippingAddress";
import { FormItem, useForm } from "../common/useForm";

const initialSchema: FormItem[] = [
  {
    type: 'text',
    name: 'lastName',
    value: '',
    placeholder: '姓をご記入ください',
    validate: (value) => {
      const v = value as string;
      return v.length > 0;
    },
    error: '必須入力項目です。'
  },
  {
    type: 'text',
    name: 'firstName',
    value: '',
    placeholder: '名をご記入ください',
    validate: (value) => {
      const v = value as string;
      return v.length > 0;
    },
    error: '必須入力項目です。'
  },
  {
    type: 'text',
    name: 'company',
    value: '',
    placeholder: '会社名の必要があればご記入ください'
  },
  {
    type: 'text',
    name: 'phone',
    value: '',
    placeholder: '半角数字(ハイフンなし)',
    validate: (value) => {
      const v = value as string;
      return v.length > 0;
    },
    error: '必須入力項目です。'
  },
  {
    type: 'text',
    name: 'zip',
    value: '',
    placeholder: '郵便番号(ハイフンなし)',
    validate: (value) => {
      const v = value as string;
      return v.length > 0;
    },
    error: '必須入力項目です。'
  },
  {
    type: 'select',
    name: 'countryCode',
    value: '',
    validate: (value) => {
      const v = value as string;
      return v.length > 0;
    },
    error: '値を選択してください。',
    items: [] // カスタムフック内で定義
  },
  {
    type: 'select',
    name: 'provinceCode',
    value: '',
    validate: (value) => {
      const v = value as string;
      return v.length > 0;
    },
    error: '値を選択してください。',
    items: [] // カスタムフック内で定義
  },
  {
    type: 'text',
    name: 'city',
    value: '',
    placeholder: '市町村区を入力してください',
    validate: (value) => {
      const v = value as string;
      return v.length > 0;
    },
    error: '必須入力項目です。'
  },
  {
    type: 'text',
    name: 'address1',
    value: '',
    placeholder: '番地などをご記入ください',
    validate: (value) => {
      const v = value as string;
      return v.length > 0;
    },
    error: '必須入力項目です。'
  },
  {
    type: 'text',
    name: 'address2',
    value: '',
    placeholder: '必要あればその他建物名・部屋番号などご記入ください',
  },
];

export const useShippingAddressForm = (
  shippingAddress: ShippingAddress | undefined
) => {
  const addressFormatter = new AddressFormatter.default("ja");

  const [country, setCountry] = useState<AddressFormatter.Country>();
  const [countries, setCountries] = useState<AddressFormatter.Country[]>();
  const [schema, setSchema] = useState<FormItem[]>(initialSchema);

  const formRef = useForm(schema);

  // 国リスト・都道府県リストを取得
  useEffect(() => {
    if (!shippingAddress?.countryCode) return;

    (async() => {
      const countryCode = shippingAddress.countryCode as string;
      const _country = await addressFormatter.getCountry(countryCode);
      const _countries = await addressFormatter.getCountries();
      setCountries(_countries);
      setCountry(_country);
    })();
  }, [shippingAddress]);

  // 国リスト・都道府県リストを取得後それを反映する
  useEffect(() => {
    if (!countries || !country || !shippingAddress) return;

    // 初期値を決定する(item.value)
    const countryCodeItems = countries.map(({code, name}) => ({name, value: code}));
    const provinceCodeItems = country.zones.map(({code, name}) => ({name, value: code}));

    // 取得したリストを選択要素(items)としてschemaに追加する
    const updatedSchema = schema.map(item => {
      if (item.name === 'countryCode') item.items = countryCodeItems;
      if (item.name === 'provinceCode') item.items = provinceCodeItems;
      const s = shippingAddress as any;
      item.value = s[item.name] || '';
      return item;
    });

    setSchema(updatedSchema);

  }, [countries, country, shippingAddress]);

  return { formRef, countries, country };
};